import Action from "../base/action";
import { ResourceTypeEnum } from "../base/training-literals";

class BaseAnimationAction extends Action {
    animationId;
    meshType;
    meshName;

    constructor(props) {
        super(props);
        this.animationId = props.animationId;
        this.meshType = props.meshType;
        this.meshName = props.meshName;
        this.loop = props.loop;
    }

    getBranchId(training) {
        switch (this.meshType) {
            case 'model': {
                const trainingModelId = this.meshName.id;
                const resources = training.resources;
                const resource = resources?.[trainingModelId];
                const resourceId = resource ? (resource.resourceId || (resource.type === ResourceTypeEnum.HELPER_OBJECT && resource.id)) : '';
                return resourceId;
            }
            case 'volume':
                return this.meshName.id;
            case 'tree':
            case 'group':
                return this.meshName;
            default:
                return '';
        }
    }
}

export default BaseAnimationAction;
